module.exports = __webpack_public_path__ + "img/wyb.a854e727.jpg";